export const pipe = (x0, ...fns) => {
  return fns.reduce((x, fn) => {
    return fn(x)
  }, x0)
}
